import { NOTIFICATIONS } from "consts/notifications";

export enum Field {
  AllowAccountActivation = "allowAccountActivation",
  RequireInvitation = "requireInvitation",
  ExchangeRateValue = "exchangeRateValue",
  BalanceExpirationDays = "balanceExpirationDays",
  MinimumOrderValue = "minimumOrderValue",
  MinimumTopUpValue = "minimumTopUpValue",
  AgentRoleRefundAddLimit = "agentRoleRefundAddLimit",
  AgentRoleBalanceExpirationLimit = "agentRoleBalanceExpirationLimit",
  ManagerRoleRefundAddLimit = "managerRoleRefundAddLimit",
  ManagerRoleBalanceExpirationLimit = "managerRoleBalanceExpirationLimit",
  AgentRoleRefundAddLimitId = "agentRoleRefundAddLimitId",
  AgentRoleBalanceExpirationLimitId = "agentRoleBalanceExpirationLimitId",
  ManagerRoleRefundAddLimitId = "managerRoleRefundAddLimitId",
  ManagerRoleBalanceExpirationLimitId = "managerRoleBalanceExpirationLimitId",
}

export const notificationMessage = {
  [Field.AllowAccountActivation]: NOTIFICATIONS.FRIENDS_CODE_SHARING_UPDATED,
  [Field.RequireInvitation]: NOTIFICATIONS.ACCESS_APP_INVITATION_UPDATED,
  [Field.ExchangeRateValue]: NOTIFICATIONS.EXCHANGE_RATE_UPDATED,
  [Field.BalanceExpirationDays]: NOTIFICATIONS.BALANCE_EXPIRATION_DAYS_UPDATED,
  [Field.MinimumOrderValue]: NOTIFICATIONS.MIN_ORDER_COINS_UPDATED,
  [Field.MinimumTopUpValue]: NOTIFICATIONS.MIN_TOP_UP_UPDATED,
};

export type StateValues = {
  [Field.AllowAccountActivation]: undefined | boolean;
  [Field.RequireInvitation]: undefined | boolean;
  [Field.BalanceExpirationDays]: undefined | number;
  [Field.ExchangeRateValue]: undefined | number;
  [Field.MinimumOrderValue]: undefined | number;
  [Field.MinimumTopUpValue]: undefined | number;
  [Field.AgentRoleRefundAddLimit]: undefined | number;
  [Field.AgentRoleBalanceExpirationLimit]: undefined | number;
  [Field.ManagerRoleRefundAddLimit]: undefined | number;
  [Field.ManagerRoleBalanceExpirationLimit]: undefined | number;
  [Field.AgentRoleRefundAddLimitId]?: undefined | number;
  [Field.AgentRoleBalanceExpirationLimitId]?: undefined | number;
  [Field.ManagerRoleRefundAddLimitId]?: undefined | number;
  [Field.ManagerRoleBalanceExpirationLimitId]?: undefined | number;
};

export const initialState: StateValues = {
  [Field.AllowAccountActivation]: undefined,
  [Field.RequireInvitation]: undefined,
  [Field.BalanceExpirationDays]: undefined,
  [Field.ExchangeRateValue]: undefined,
  [Field.MinimumOrderValue]: undefined,
  [Field.MinimumTopUpValue]: undefined,
  [Field.AgentRoleRefundAddLimit]: undefined,
  [Field.AgentRoleBalanceExpirationLimit]: undefined,
  [Field.ManagerRoleRefundAddLimit]: undefined,
  [Field.ManagerRoleBalanceExpirationLimit]: undefined,
  [Field.AgentRoleRefundAddLimitId]: undefined,
  [Field.AgentRoleBalanceExpirationLimitId]: undefined,
  [Field.ManagerRoleRefundAddLimitId]: undefined,
  [Field.ManagerRoleBalanceExpirationLimitId]: undefined,
};

export type LoadingStateValues = Record<
  keyof Omit<
    StateValues,
    | "agentRoleRefundAddLimitId"
    | "agentRoleBalanceExpirationLimitId"
    | "managerRoleRefundAddLimitId"
    | "managerRoleBalanceExpirationLimitId"
  >,
  boolean
>;

export const initialLoadingState: LoadingStateValues = {
  [Field.AllowAccountActivation]: false,
  [Field.RequireInvitation]: false,
  [Field.BalanceExpirationDays]: false,
  [Field.ExchangeRateValue]: false,
  [Field.MinimumOrderValue]: false,
  [Field.MinimumTopUpValue]: false,
  [Field.AgentRoleRefundAddLimit]: false,
  [Field.AgentRoleBalanceExpirationLimit]: false,
  [Field.ManagerRoleRefundAddLimit]: false,
  [Field.ManagerRoleBalanceExpirationLimit]: false,
};
